import { useColors } from '../../hooks/useColors'

type FilterPill = { key: string; label: string; onClear: () => void }

export default function OrderFilters({ hasFilters, pills, onClearAll }: { hasFilters: boolean; pills: FilterPill[]; onClearAll: () => void }) {
  const colors = useColors()
  if (!hasFilters) return null
  return (
    <section style={{ padding: '8px 32px 0', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      {pills.map((pill) => (
        <span key={pill.key} className="font-body" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: colors.accent, color: colors.bgSidebar, borderRadius: '999px', padding: '6px 12px', fontSize: '13px', fontWeight: 500 }}>
          {pill.label}
          <button type="button" onClick={pill.onClear} style={{ border: 'none', background: 'transparent', color: colors.bgSidebar, cursor: 'pointer', fontSize: '13px', fontWeight: 700, padding: 0 }}>×</button>
        </span>
      ))}
      <button type="button" onClick={onClearAll} className="font-body" style={{ border: `1.5px solid ${colors.accent}`, color: colors.accentText, background: 'transparent', borderRadius: '999px', padding: '6px 12px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>Clear all</button>
    </section>
  )
}
